const ERRORS = [
  {
    status: "400",
    when: "Unknown filter name",
    example: '{"detail": "Allowed parameters are id, short_name, long_name, desc, region"}',
  },
  { status: "404", when: "No record with that id", example: '{"detail": "Not found."}' },
];

export function ApiErrorsSection() {
  return (
    <section className="apiResource" id="errors" aria-labelledby="apiErrorsTitle">
      <div className="apiResourceHeader">
        <span className="apiEyebrow">Reference</span>
        <h2 className="apiResourceTitle" id="apiErrorsTitle">Errors</h2>
        <p className="apiBody">
          Errors come back as JSON with one <code className="apiInlineCode">detail</code> field. The status code tells
          you what to fix.
        </p>
      </div>
      <table className="apiTable">
        <thead>
          <tr>
            <th className="apiTableColType">Status</th>
            <th className="apiTableColName">When</th>
            <th>Example</th>
          </tr>
        </thead>
        <tbody>
          {ERRORS.map((e) => (
            <tr key={e.status}>
              <td><span className="apiParamName">{e.status}</span></td>
              <td>{e.when}</td>
              <td><code className="apiInlineCode">{e.example}</code></td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
